import { httpClient } from "util/Api";

// 根据 moduleId 加载 WorkflowStatus 下拉选项
function loadWorkflowStatusByModuleId(moduleId, sectionComponent, workflowStatusIdList) {
  if (moduleId) {
    httpClient
      .get('Admin/WorkflowStatus/GetSelectOptionList?moduleId=' + moduleId)
      .then(({ data }) => {
        if (data.result) {
          // 使用函数式 setState 避免并发请求覆盖彼此的数据
          sectionComponent.customForm.current?.setState((prevState) => {
            let componentDataSource = { ...prevState.componentDataSource };
            componentDataSource['WorkflowStatusIdList'] = data.data.filter(item => item.Value !== 0);
            return { componentDataSource };
          }, () => {
            if (workflowStatusIdList) {
              sectionComponent.customForm.current?.formRef.current?.setFieldValue('WorkflowStatusIdList', workflowStatusIdList);
            }
          });
        }
      });
  } else {
    sectionComponent.customForm.current?.setState((prevState) => {
      let componentDataSource = { ...prevState.componentDataSource };
      componentDataSource['WorkflowStatusIdList'] = [];
      return { componentDataSource };
    });
  }
}

// 根据 moduleId 加载 Label 下拉选项
function loadLabelByModuleId(moduleId, sectionComponent, labelIdList) {
  if (moduleId) {
    httpClient
      .get('Admin/Label/GetSelectOptionList?moduleId=' + moduleId)
      .then(({ data }) => {
        if (data.result) {
          // 使用函数式 setState 避免并发请求覆盖彼此的数据
          sectionComponent.customForm.current?.setState((prevState) => {
            let componentDataSource = { ...prevState.componentDataSource };
            componentDataSource['LabelIdList'] = data.data.filter(item => item.Value !== 0);
            return { componentDataSource };
          }, () => {
            if (labelIdList) {
              sectionComponent.customForm.current?.formRef.current?.setFieldValue('LabelIdList', labelIdList);
            }
          });
        }
      });
  } else {
    sectionComponent.customForm.current?.setState((prevState) => {
      let componentDataSource = { ...prevState.componentDataSource };
      componentDataSource['LabelIdList'] = [];
      return { componentDataSource };
    });
  }
}

export function moduleIdOnChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  // 编辑初始化时跳过，防止 getUieDataSource 自动设默认值后触发的 onChange 覆盖已有数据
  if (sectionComponent._jobListTabEditInit) {
    sectionComponent._jobListTabEditInit = false;
    return;
  }
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('WorkflowStatusIdList', []);
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('LabelIdList', []);
  loadWorkflowStatusByModuleId(parameter, sectionComponent, null);
  loadLabelByModuleId(parameter, sectionComponent, null);
}

export function addJobListTabPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent._jobListTabEditInit = false;
  let moduleId = sectionComponent.customForm.current?.formRef.current?.getFieldValue('ModuleId');
  loadWorkflowStatusByModuleId(moduleId, sectionComponent, null);
  loadLabelByModuleId(moduleId, sectionComponent, null);
}

export function editJobListTabPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie, data } = {}) {
  // 标记编辑初始化中，让 moduleIdOnChange 跳过一次（防止 getUieDataSource 触发的干扰）
  sectionComponent._jobListTabEditInit = true;
  loadWorkflowStatusByModuleId(data?.ModuleId, sectionComponent, data?.WorkflowStatusIdList);
  loadLabelByModuleId(data?.ModuleId, sectionComponent, data?.LabelIdList);
}
